import { mapGetters } from 'vuex'
import types from '../../store/globaltypes'
import cropinfo from '../../components/cropinfo'
import cultivationmethods from '../../components/cultivationmethods'

export default {
  name: 'single-crop',
  components: { cropinfo, cultivationmethods },
  props: [],
  data () {
    return {
      crop: null,
      active: 'tab-info'
    }
  },
  computed: {
    ...mapGetters({
      cropGetter: types.crops.getters.crop,
      crops: types.crops.getters.crops,
      cropById: types.crops.getters.cropById,
      translatePostID: types.i18n.getters.translatePostID
    }),
    sunNeeded () {
      return this.checkOption(this.crop['sunexposure'])
    },
    wateringNeeded () {
      return this.checkOption(this.crop['watering'])
    },
    fertilizingNeeded () {
      return this.checkOption(this.crop['fertilizing'])
    }
  },
  activated () {
    this.crop = this.cropGetter(this.$route.params.cropname)
  },
  methods: {
    checkOption (value) {
      var toRet = 1
      if (value === 'medium' || value === 'moderate') toRet = 2
      if (value === 'a lot' || value === 'yes') toRet = 3

      return toRet
    }
  },
  watch: {
    crops: function (val) {
      if (this.$router.currentRoute.name === 'cropinfo') {
        this.crop = this.cropGetter(this.$route.params.cropname)

        const translatedID = this.translatePostID(this.crop.key)
        if (this.crop.key !== translatedID) {
          this.crop = this.cropById(translatedID)
          this.$router.push({ name: 'cropinfo', params: { cropname: this.crop.post_title.toLowerCase() } })
        }
      }
    }
  }
}
